var _effectorFileName = "/builds/gmini/front-ui-kit/src/SelectMultiple/hooks/useSelectVariables.tsx";
import React, { useRef, useState } from 'react';
export const useSelectVariables = () => {
  const [focusedOptionIdx, setFocusedOptionIdx] = useState(0);
  const [inputValue, setInputValue] = useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);
  return {
    inputValue,
    setInputValue,
    anchorEl,
    setAnchorEl,
    focused,
    setFocused,
    inputRef,
    focusedOptionIdx,
    setFocusedOptionIdx
  };
};